import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SpecialPlaceService } from './special-place.service';
import { getSpecialPlaceIdentifier, ISpecialPlace } from '../models/special-place.model';
import { Observable } from 'rxjs';
import { ApplicationConfigService } from './application-config.service';
import { ApiProviderService } from './api-provider.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { createRequestOption } from '../app/shared/util/request-util';

export type EntityResponseType = HttpResponse<ISpecialPlace>;
export type EntityArrayResponseType = HttpResponse<ISpecialPlace[]>;

@Injectable({ providedIn: 'root' })
export class SpecialPlaceExtendedService extends SpecialPlaceService {
  protected specialPlaceUrl = API_ENDPOINTS.SPECIAL_PLACE;

  constructor(private apiProvider: ApiProviderService, http: HttpClient, applicationConfigService: ApplicationConfigService) {
    super(http, applicationConfigService);
  }

  override create(specialPlace: ISpecialPlace): Observable<EntityResponseType> {
    return this.apiProvider.post<ISpecialPlace>(this.specialPlaceUrl, specialPlace, { observe: 'response' });
  }

  override update(specialPlace: ISpecialPlace): Observable<EntityResponseType> {
    return this.apiProvider.put<ISpecialPlace>(`${this.specialPlaceUrl}/${getSpecialPlaceIdentifier(specialPlace)}`, specialPlace);
  }

  override partialUpdate(specialPlace: ISpecialPlace): Observable<EntityResponseType> {
    return this.apiProvider.patch<ISpecialPlace>(`${this.specialPlaceUrl}/${getSpecialPlaceIdentifier(specialPlace)}`, specialPlace);
  }

  override find(id: number): Observable<EntityResponseType> {
    return this.apiProvider.get<ISpecialPlace>(`${this.specialPlaceUrl}/${id}`, { observe: 'response' });
  }

  override query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.apiProvider.get<ISpecialPlace[]>(this.specialPlaceUrl, { params: options, observe: 'response' });
  }

  override delete(id: number): Observable<HttpResponse<{}>> {
    return this.apiProvider.delete(`${this.specialPlaceUrl}/${id}`);
  }

  override addSpecialPlaceToCollectionIfMissing(specialPlaceCollection: ISpecialPlace[], ...specialPlacesToCheck: any[]): ISpecialPlace[] {
    return super.addSpecialPlaceToCollectionIfMissing(specialPlaceCollection, ...specialPlacesToCheck);
  }

  public deleteList(listId: number): Observable<HttpResponse<{}>> {
    return this.apiProvider.delete(`${this.specialPlaceUrl}/list/${listId}`);
  }
}
